import { useMemo } from 'react';

export const useQueryParams = () => {
  return useMemo((): any => new URLSearchParams(window.location.search), []);
};

export const locationReload = () => {
  window.location.href = window.location.origin + window.location.pathname + window.location.search;
};
